/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module maxSafeInteger
 */

export default 9007199254740991;
